var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94011 12.6459L7.69211 11.8969C5.33911 11.1129 4.16211 10.7209 4.16211 9.99986C4.16211 9.27986 5.33911 8.88686 7.69211 8.10286L16.2051 5.26486C17.8611 4.71286 18.6891 4.43686 19.1261 4.87386C19.5631 5.31086 19.2871 6.13886 18.7361 7.79386L15.8971 16.3079C15.1131 18.6609 14.7211 19.8379 14.0001 19.8379C13.2801 19.8379 12.8871 18.6609 12.1031 16.3079L11.3531 14.0609L15.7071 9.70686C15.8893 9.51826 15.9901 9.26566 15.9878 9.00346C15.9855 8.74126 15.8803 8.49045 15.6949 8.30504C15.5095 8.11963 15.2587 8.01446 14.9965 8.01219C14.7343 8.00991 14.4817 8.1107 14.2931 8.29286L9.94011 12.6459Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.257d48a3fa6795aba7622fdd40e07774.svg";
export { ForwardRef as ReactComponent };